import { Form, Formik, FormikErrors, FormikProps } from 'formik';

import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { FormButton } from '../../../_core/form/button/form-button.component';
import { IRIFormProps } from '../../../_core/form/form.types';
import { useFetchCurrUser } from '../../users/user.service';
import { TEMPLATE_TYPE } from '../../../../lib/types';
import { IMultiSelectOption } from '../../../_core/input/multiselect-input.component';

const REQUEST_TYPE_OPTIONS = [
  {
    value: TEMPLATE_TYPE.REQUEST,
    label: 'Request',
    secondaryLabel: 'A template that can be directly used to create requests'
  },
  {
    value: TEMPLATE_TYPE.BLOCK,
    label: 'Block',
    secondaryLabel: 'A single component of a form (eg. a question)'
  },
  {
    value: TEMPLATE_TYPE.SECTION,
    label: 'Section',
    secondaryLabel: 'A subsection of a larger request template'
  }
];

export interface ICreateBlankTemplateFormValues {
  description?: string;
  isGlobal?: boolean;
  title: string;
  type: IMultiSelectOption[];
}

export const CreateBlankTemplateForm = ({ onSubmit }: IRIFormProps<ICreateBlankTemplateFormValues>) => {
  const { isGlobalAdmin } = useFetchCurrUser();

  const validateForm = (values: ICreateBlankTemplateFormValues) => {
    const errors: FormikErrors<ICreateBlankTemplateFormValues> = {};

    if (!values.title.trim()) errors.title = 'Required';

    return errors;
  };

  return (
    <Formik
      initialValues={
        {
          title: '',
          description: '',
          isGlobal: false,
          type: [REQUEST_TYPE_OPTIONS[0]]
        } as ICreateBlankTemplateFormValues
      }
      onSubmit={(values) =>
        onSubmit({ ...values, description: values.description?.trim(), title: values.title.trim() })
      }
      validate={validateForm}
      validateOnBlur={false}
    >
      {(props: FormikProps<ICreateBlankTemplateFormValues>) => (
        <Form
          action="#"
          method="POST"
          className="flex flex-col sm:max-w-xl mx-auto space-y-2 mt-10 items-center w-full"
        >
          <FormInputWithLabel name="title" label="Title" />
          <FormInputWithLabel name="description" label="Description" />
          <FormInputWithLabel
            name="type"
            label="Type"
            type="multiselect"
            multiSelectProps={{ nullable: true, singleSelect: true, options: REQUEST_TYPE_OPTIONS }}
          />
          {!!isGlobalAdmin && <FormInputWithLabel name="isGlobal" label="Globally Available" type="checkbox" />}
          <FormButton loading={props.isSubmitting} text="Create" size="large" />
        </Form>
      )}
    </Formik>
  );
};
